import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

@Component({
  selector: 'app-date-input',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatDatepickerModule, MatNativeDateModule],
  template: `
    <div [formGroup]="parentForm" class="flex items-center justify-between text-xs w-full">
        <!-- Label and Input Wrapper -->
        <div class="flex-1 flex items-center gap-2">
            <span *ngIf="label" class="text-xs font-semibold whitespace-nowrap" [style.min-width]="labelWidth">
                {{ label }}
            </span>
            
            <input 
                (click)="picker.open()" 
                readonly
                [matDatepicker]="picker"
                [min]="min" 
                class="placeholder-gray-500 bg-transparent focus:outline-none w-full h-30-px rounded-md pl-3 italic cursor-pointer" 
                [formControlName]="controlName" 
                type="text" 
                [placeholder]="placeholder">
                
            <mat-datepicker #picker></mat-datepicker>   
        </div>

        <!-- SVG Icon (Clickable) -->
        <div class="ml-2">
            <svg 
                (click)="picker.open()" 
                class="focus:outline-none cursor-pointer" 
                xmlns="http://www.w3.org/2000/svg" 
                width="19" height="19" viewBox="0 0 19 19">
                <path id="Path_371" data-name="Path 371" d="M16.625,0H14.25V1.188H4.75V0H2.375V1.188H0V19H19V1.188H16.625Zm1.188,5.938V17.813H1.188V5.938Z" fill="#5f4d9c"/>
                <rect id="Rectangle_630" data-name="Rectangle 630" width="4" height="4" transform="translate(13 6.936)" fill="#5f4d9c"/>
                <rect id="Rectangle_631" data-name="Rectangle 631" width="4" height="4" transform="translate(13 11.936)" fill="#5f4d9c"/>
                <rect id="Rectangle_632" data-name="Rectangle 632" width="4" height="4" transform="translate(8 11.936)" fill="#5f4d9c"/>
                <rect id="Rectangle_633" data-name="Rectangle 633" width="4" height="4" transform="translate(3 11.936)" fill="#5f4d9c"/>
                <rect id="Rectangle_634" data-name="Rectangle 634" width="4" height="4" transform="translate(8 6.936)" fill="#5f4d9c"/>
                <rect id="Rectangle_635" data-name="Rectangle 635" width="4" height="4" transform="translate(3 6.936)" fill="#5f4d9c"/>
            </svg>
        </div>
    </div>
  `
})
export class DateInputComponent {
  @Input() label = '';
  @Input() parentForm!: FormGroup; 
  @Input() controlName = ''; 
  @Input() placeholder = 'dd/mm/yy';
  @Input() labelWidth = 'auto'; 
  @Input() min: Date | null = null; 
}
